module.exports = __webpack_public_path__ + "static/media/4.0f64f8d5.svg";